document.addEventListener('DOMContentLoaded', () => {
  const ACTIVE_FLANKER = 'godfather-flanker-chapter__flanker-item--active';
  const ACTIVE_CHAPTER = 'godfather-flanker-chapter__chapter-card--active';

  const initSection = (sectionEl) => {
    if (sectionEl.dataset.godfatherFlankerInitialized) return;
    sectionEl.dataset.godfatherFlankerInitialized = 'true';

    const flankerItems = [...sectionEl.querySelectorAll('[data-flanker-index]')];
    const chapterCards = [...sectionEl.querySelectorAll('[data-chapter-index]')];
    const detailPanels = [...sectionEl.querySelectorAll('[data-detail-index]')];

    if (flankerItems.length === 0 && chapterCards.length === 0) return;

    const activate = (index) => {
      const i = parseInt(index, 10);

      for (const item of flankerItems) item.classList.remove(ACTIVE_FLANKER);
      for (const card of chapterCards) card.classList.remove(ACTIVE_CHAPTER);
      for (const panel of detailPanels) panel.setAttribute('hidden', '');

      const targetFlanker = flankerItems.find((item) => parseInt(item.dataset.flankerIndex, 10) === i);
      const targetChapter = chapterCards.find((card) => parseInt(card.dataset.chapterIndex, 10) === i);
      const targetDetail = detailPanels.find((panel) => parseInt(panel.dataset.detailIndex, 10) === i);

      if (targetFlanker) targetFlanker.classList.add(ACTIVE_FLANKER);
      if (targetChapter) targetChapter.classList.add(ACTIVE_CHAPTER);
      if (targetDetail) targetDetail.removeAttribute('hidden');
    };

    const flankerGrid = sectionEl.querySelector('.godfather-flanker-chapter__flanker-grid');
    const chapterGrid = sectionEl.querySelector('.godfather-flanker-chapter__chapter-grid');

    if (flankerGrid) {
      flankerGrid.addEventListener('click', (event) => {
        const item = event.target.closest('[data-flanker-index]');
        if (item) activate(item.dataset.flankerIndex);
      });

      flankerGrid.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const item = event.target.closest('[data-flanker-index]');
        if (item) {
          event.preventDefault();
          activate(item.dataset.flankerIndex);
        }
      });
    }

    if (chapterGrid) {
      chapterGrid.addEventListener('click', (event) => {
        const card = event.target.closest('[data-chapter-index]');
        if (card) activate(card.dataset.chapterIndex);
      });

      chapterGrid.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-chapter-index]');
        if (card) {
          event.preventDefault();
          activate(card.dataset.chapterIndex);
        }
      });
    }
  };

  document.querySelectorAll('[data-godfather-flanker-chapter]').forEach(initSection);
});
